import { Navigate, useLocation } from 'react-router-dom';
import { useStateValue } from '../hooks/UseStateValue';
import { ROUTE_NAMES } from './RouterApp';
import * as Storage from '../classes/Storage';

const RouterCondition = (props: any) => {
  const [{ statusInitial, actualStep, previousStep }] = useStateValue();
  const { children } = props;
  const location = useLocation();
  const basename = children?.props?.basename;

  // If we have reloaded the page and not on intro page
  if (statusInitial && location.pathname !== ROUTE_NAMES.OCCUPATION) {
    const key = Storage.getSessionItem('onsa-personal-injury-cache-key');
    if (key) {
      return <>{children}</>;
    } else if (basename?.indexOf('kvittering') === -1) {
      return <Navigate to={ROUTE_NAMES.OCCUPATION} />;
    } else {
      // an error must have occurred
    }
  }

  // Prevent the customer from jumping forward in the flow
  if (actualStep > 1 && actualStep < 9 && actualStep - previousStep > 1 && !window.topContext.user.isLoggedOn) {
    return <Navigate to={ROUTE_NAMES.OCCUPATION} />;
  }

  return <>{children}</>;
};

export { RouterCondition };
